import { render, staticRenderFns } from "./ProjectTeacherEdit.vue?vue&type=template&id=60f88848&"
import script from "./ProjectTeacherEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectTeacherEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports